module.exports = new __parcel__URL__("logo_aqta.e902dd37.png").toString();